export default __webpack_public_path__ + "static/media/DharmaGothicE_ExBold_R.8fc84353.otf";